module.exports = __webpack_public_path__ + "img/speaker-guide.463bea2f.png";